<svg:g ecg-trace *ngFor="let trace of layer?.drawableTraces" [trace]="trace" [attr.transform]="layer.translate"></svg:g>
